class LocalServiceFsApis {
  constructor(service) {
    this.service = service;
  }

  async list(dirPath, params = {}) {
    const {
      data
    } = await this.service.get({
      path: "/fs/list",
      query: {
        dirPath,
        ...params
      }
    });
    return data;
  }

  async dirs(path, params = {}) {
    const {
      data
    } = await this.service.get({
      path: "/fs/dirs",
      query: {
        path,
        ...params
      }
    });
    return data;
  }

  async tree(path, params = {}) {
    const {
      data
    } = await this.service.get({
      path: "/fs/tree",
      query: {
        path,
        ...params
      }
    });
    return data;
  }

  async stat(path, params = {}) {
    const {
      data
    } = await this.service.get({
      path: "/fs/stat",
      query: {
        path,
        ...params
      }
    });
    return data;
  }

  async read(path, params = {}) {
    const {
      data
    } = await this.service.get({
      path: "/fs/read",
      query: {
        path,
        ...params
      }
    });
    return data;
  }

  async lines(path, params = {}) {
    const {
      data
    } = await this.service.get({
      path: "/fs/lines",
      query: {
        path,
        ...params
      }
    });
    return data;
  }

  async write(dirPath, filename, contents) {
    const {
      data
    } = await this.service.post({
      path: "/fs/write",
      body: {
        dirPath,
        filename,
        contents
      }
    });
    return data;
  }

  async rename(oldPath, newPath) {
    const {
      data
    } = await this.service.put({
      path: "/fs/rename",
      body: {
        oldPath,
        newPath
      }
    });
    return data;
  }

  async move(oldPath, newPath) {
    const {
      data
    } = await this.service.put({
      path: "/fs/move",
      body: {
        oldPath,
        newPath
      }
    });
    return data;
  }

  async append(path, contents) {
    const {
      data
    } = await this.service.put({
      path: "/fs/append",
      body: {
        path,
        contents
      }
    });
    return data;
  }

  async remove(path) {
    const {
      data
    } = await this.service.delete({
      path: "/fs/remove",
      body: {
        path
      }
    });
    return data;
  }

}

export default LocalServiceFsApis;